import styled from "styled-components";
import Tabs from "../../../../../structures/others/tabs/index.js";
import { TabsButton } from "../../../../../structures/others/tabs/styled.js";
import { FlexMixin, FontMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
export const LocationTabLabel = styled.span.withConfig({
    displayName: "styled__LocationTabLabel",
    componentId: "sc-7fe2362c-0"
})`
	${FontMixin({
    size: 'small',
    height: 'medium'
})}
	color: ${({ theme  })=>theme.colors.grays.base};
	display: block;
	margin-bottom: 4px;
	overflow: hidden;
	text-overflow: ellipsis;
	text-transform: none;
	white-space: nowrap;
	width: 100%;
`;
export const LocationTabLabelContent = styled.span.withConfig({
    displayName: "styled__LocationTabLabelContent",
    componentId: "sc-7fe2362c-1"
})`
	${FontMixin({
    size: 'base',
    height: 'base'
})}
	display: block;
	overflow: hidden;
	text-overflow: ellipsis;
	text-transform: none;
	white-space: nowrap;
	width: 100%;
`;
export const LocationTabs = styled(Tabs).withConfig({
    displayName: "styled__LocationTabs",
    componentId: "sc-7fe2362c-2"
})`
	${TabsButton} {
		&.is-active {
			${LocationTabLabel} {
				color: ${({ theme  })=>theme.colors.white.base};
			}
		}
	}
`;
export const LocationItem = styled.div.withConfig({
    displayName: "styled__LocationItem",
    componentId: "sc-7fe2362c-3"
})`
	${FlexMixin({
    align: 'center',
    justify: 'space-between'
})}
	flex: 1 0 0;
	position: relative;
	width: 50%;

	&:first-child {
		border-right: 1px solid ${({ theme  })=>theme.colors.grays.light};
	}
`;
export const LocationInputIcon = styled.div.withConfig({
    displayName: "styled__LocationInputIcon",
    componentId: "sc-7fe2362c-4"
})`
	${FontMixin({
    size: 'base',
    height: 'base'
})}
	background-color: ${({ theme  })=>theme.colors.white.base};
	color: ${({ theme  })=>theme.colors.grays.base};
	pointer-events: none;
	position: absolute;
	right: -9px;
	top: 50%;
	transform: translateY(-50%);
	z-index: ${({ theme  })=>theme.zIndex.lowest};
`;

//# sourceMappingURL=styled.js.map